<style scoped>
    .foot {
        padding-top: 20px;
        margin-top: 20px;
    }
</style>
<template>
    <div style="padding: 20px 0;">
        <div style="font-size: 20px;padding: 0 20px;">
            <div>个人中心</div>
        </div>
        <div style="border-top: 1px solid #f1f1f1;border-bottom: 1px solid #f1f1f1;margin-top: 20px;padding: 20px;">
            <div v-if="!nameInput">
                <div style="font-size: 24px;">
                    {{session.zhanghao.name}}
                    <Icon type="ios-create-outline" class="hover" @click="nameInput=true;form.zhenshixingming=session.zhanghao.name"></Icon>
                </div>
                <div>{{session.jigou.jituan.name}}<span v-if="session.jigou.name!=session.jigou.jituan.name"> - {{session.jigou.name}}</span>（ {{session.jigou.code}} ）</div>

            </div>
            <div style="font-size: 24px;padding: 20px;display: flex;align-items: center;" v-if="nameInput">
                <span style="font-size: 14px;">修改真实姓名:</span>
                <Input v-model="form.zhenshixingming" style="width: 180px;margin-left: 20px;" />
                <Button type="default" style="margin-left: 10px;" @click="nameInput=false">取消</Button>
                <Button type="primary" style="margin-left: 10px;" @click="nameChanged">确定</Button>
            </div>
        </div>
        <div class="jcsb" style="padding: 20px;" v-if="!phoneInput">
            <div>
                <div style="font-size: 18px;font-weight: bold;">手机号</div>
                <div>已绑定手机号：{{session.user.phone}}</div>
            </div>
            <div style="display: flex;align-items: center;">
                <div>
                    <Button @click="toBindWechat" style="margin-right: 10px;" type="primary" v-if="!session.user.pubopenid">绑定微信</Button>
                    <Button @click="toBindWechat" style="margin-right: 10px;" type="primary" v-else>解绑微信</Button>
                </div>
                <Button @click="phoneInput=true">更换手机号</Button>
            </div>
        </div>
        <div v-if="phoneInput">
            <div v-if="phoneInputStep==1">
                <div style="padding: 20px;display: flex;align-items: center;" v-if="codeSend==false">
                    <div>验证原手机号:{{session.user.phone}}</div>
                    <Button type="primary" style="margin-left: 10px;" @click="sendCode(session.user.phone)">发送验证码</Button>
                    <Button type="default" style="margin-left: 10px;" @click="phoneInput=false">取消</Button>
                </div>
                <div style="padding: 20px;" v-if="codeSend">
                    <div>请输入原手机号:{{session.user.phone}}收到的验证码</div>
                    <div style="display: flex;margin-top: 10px;">
                        <Input v-model="form.smscode" style="width: 100px;" placeholder="请输入验证码" />
                        <Button type="default" disabled style="margin-left: 10px;" v-if="cd>0">重新获取（{{cd}})</Button>
                        <Button type="primary" style="margin-left: 10px;" @click="sendCode(session.user.phone)" v-if="cd <= 0">重新获取</Button>
                        <Button type="default" style="margin-left: 10px;" @click="phoneInput=false" v-if="!form.smscode">取消</Button>
                        <Button type="primary" style="margin-left: 10px;" @click="checkCode()" v-if="form.smscode">继续</Button>
                    </div>
                </div>
            </div>
            <div v-if="phoneInputStep==2">
                <div style="padding: 20px;" v-if="!codeSend">
                    <span>请输入新手机号：</span>
                    <Input v-model="form.phone" style="width: 200px;" />
                    <Button type="default" disabled style="margin-left: 10px;" v-if="cd>0">获取验证码（{{cd}})</Button>
                    <Button type="primary" style="margin-left: 10px;" @click="sendCode(form.phone)" v-if="cd <= 0">获取验证码</Button>
                    <Button type="default" style="margin-left: 10px;" @click="phoneInputStep=1">返回</Button>
                </div>
                <div style="padding: 20px;" v-if="codeSend">
                    <div>请输入新手机号:{{form.phone}}收到的验证码</div>
                    <div style="display: flex;margin-top: 10px;">
                        <Input v-model="form.smscode" style="width: 100px;" placeholder="请输入验证码" />
                        <Button type="default" disabled style="margin-left: 10px;" v-if="cd>0">重新获取（{{cd}})</Button>
                        <Button type="primary" style="margin-left: 10px;" @click="sendCode(form.phone)" v-if="cd <= 0">重新获取</Button>
                        <Button type="default" style="margin-left: 10px;" @click="codeSend=false;" v-if="!form.smscode">返回</Button>
                        <Button type="primary" style="margin-left: 10px;" @click="savePhone" v-if="form.smscode">完成</Button>
                    </div>
                </div>
            </div>
        </div>
        <div style="padding: 20px;border-top: 1rpx solid #f1f1f1;" v-if="zhengshuguanli && session && session.zhanghao && (!session.zhanghao.jituanadmin) && session.zhanghao.zhengshu">
            <div style="font-size: 20px;font-weight: bold;">证书</div>
            <div style="margin-top: 10px;">
                <img :src="session.zhanghao.zhengshu.url + '?imageView2/1/w/200/h/300'" style="width: 100px;height:150px;">
            </div>
        </div>
        <div style="padding: 20px;border-top: 1rpx solid #f1f1f1;">
            <div style="font-size: 20px;font-weight: bold;">角色</div>
            <div v-for="(item,index) in session.zhanghao.jueses" :key="index">{{item.name}}</div>
            <div style="height: 20px;"></div>
            <div v-if="session.zhanghao.jigou.type!='MD'">
                <div style="font-size: 20px;font-weight: bold;padding: 20px 0;">管辖范围</div>
                <!-- <div v-for="(item,index) in session.zhanghao.guanxiajigous" :key="index">{{item.name}}</div> -->
                <div style="display: flex;">
                    <div style="padding: 10px;background-color: #fafafa;min-width: 200px;border-radius: 4px;">
                        <div>管辖机构</div>
                        <div style="display: flex;align-items: center;">
                            <div><span style="color: #20bf64;font-weight: bold;">{{keyongguanxiajigous.length}}</span> 个机构</div>
                        </div>
                        <div v-if="firstlevel.length" style="max-height: 500px;overflow-y:scroll;">
                            <div v-for="(item,index) in firstlevel" style="padding: 0 4px;box-sizing: border-box;position: relative;margin-top: 8px;">
                                <div :key="index" class="jcsb">
                                    <div style="width: 160px;" class="nowrap">- {{item.name}}
                                    </div>
                                    <Tag>{{item.type}}</Tag>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="width: 20px;"></div>
                    <div style="padding: 10px;background-color: #fafafa;min-width: 200px;border-radius: 4px;">
                        <div style="font-weight: bold;">管辖仓库</div>
                        <div v-if="session.zhanghao['guanxiacangkumode']=='part'"><span style="color: #20bf64;font-weight: bold;">{{session.zhanghao.guanxiacangkus.length}}</span>个仓库</div>
                        <div v-else>全部仓库</div>
                        <CustomData v-if="session.zhanghao.guanxiacangkus" :current="session.zhanghao.guanxiacangkus||[]" unimode :moveable="false" :query="{}" :fields="{_id:1,name:1,code:1,'jigou._id':1,'jigou.name':1, 'jigou.type':1,'jiagongjian._id':1,'jiagongjian.name':1,}" :multi="true" :editable="false" datatype="cangku"></CustomData>
                    </div>
                    <div style="width: 20px;"></div>
                    <div style="padding: 10px;background-color: #fafafa;min-width: 200px;border-radius: 4px;">
                        <div style="font-weight: bold;">管辖供应商</div>
                        <div v-if="session.zhanghao['guanxiagonghuojigoumode']=='part'"><span style="color: #20bf64;font-weight: bold;">{{session.zhanghao.guanxiagonghuojigous.length}}</span>个供应商</div>
                        <div v-else>全部供应商</div>
                        <CustomData v-if="session.zhanghao.guanxiagonghuojigous" :current="session.zhanghao.guanxiagonghuojigous||[]" unimode :moveable="false" :fields="{_id:1,name:1,code:1}" :multi="true" :query="{type:'KS',mendian:null}" :editable="false" datatype="jigou"></CustomData>
                    </div>
                </div>
            </div>

        </div>

        <Modal v-model="qrcodeModal" class="nopadding" footer-hide :closable="true" :width="280">
            <div class="center" style="padding: 20px 40px;">
                <div style="text-align: center;" v-if="!bind && !binderror">
                    <img v-if="qrcode" :src="qrcode.url" style="width: 240px;height: 240px;border-radius: 16rpx;" />
                    <div v-else style="color: #aaa;height: 240px;display: flex;align-items: center;justify-content: center;">二维码加载中</div>
                    <div style="text-align: center;">
                        <div style="font-size: 24px;">{{session.user.phone}}</div>
                        <div v-if="qrcodetype=='bind'">微信扫码绑定该账号</div>
                        <div v-if="qrcodetype=='unbind'">请使用绑定该账号的微信扫码解绑</div>
                    </div>
                </div>
                <div style="text-align: center;" v-else-if="binderror">
                    <Icon type="ios-close-circle" style="color: red;font-size: 80px;" />
                    <div style="height: 20px;"></div>
                    <div style="font-size: 24px;">绑定失败</div>
                    <div>{{binderror}}</div>
                </div>
                <div v-else-if="bind" style="text-align: center;">
                    <Icon type="ios-checkmark-circle" style="color: #20bf64;font-size: 80px;" />
                    <div style="height: 20px;"></div>
                    <div style="font-size: 24px;" v-if="qrcodetype=='bind'">绑定成功</div>
                    <div style="font-size: 24px;" v-if="qrcodetype=='unbind'">解除绑定成功</div>
                    <div v-if="qrcodetype=='bind'">已可使用微信扫码登陆系统</div>
                    <div v-if="qrcodetype=='unbind'">已可使用新的微信绑定该账号</div>
                </div>
            </div>
            <div style="height: 20px;"></div>
        </Modal>

    </div>
</template>
<script>
    export default {
        computed: {
            keyongguanxiajigous() {
                return this.session.zhanghao.guanxiajigous.filter(item => {
                    return item.actived === undefined || item.actived
                })
            }
        },
        data() {
            return {
                zhengshuguanli: false,
                qrcodetype: null,
                session: this.$store.session,
                loading: false,
                nameInput: false,
                phoneInput: false,
                phoneInputStep: 1,
                form: {},
                cd: -1,
                codeSend: false,
                qrcode: null,
                qrcodeModal: false,
                binderror: null,
                bind: false,
                firstlevel: [],
            }
        },
        mounted() {
            this.loadData()
        },
        methods: {
            hideChildren() {
                let firstlevel = []
                for (let item of this.keyongguanxiajigous) {
                    if (!item.parent) {
                        firstlevel.push(item)
                        continue
                    }
                    let p = item.parent ? this.keyongguanxiajigous.find(o => o._id == item.parent._id) : null
                    if (p) {
                        p.childCount = (p.childCount || 0) + 1
                        continue
                    }
                    if (item.actived !== false) firstlevel.push(item)
                }
                this.firstlevel = firstlevel
            },
            countChild(jigou, parent) {
                if (parent.parent) {
                    let parent2 = this.keyongguanxiajigous.findOne({ _id: parent.parent._id })
                    if (parent2) {
                        return this.countChild(parent, parent2)
                    }
                }
                parent.childCount++
            },
            async toBindWechat() {
                this.bind = false
                this.binderror = null
                this.qrcodeModal = true
                this.qrcodetype = this.session.user.pubopenid ? 'unbind' : 'bind'
                this.loading = true
                let res = await this.$api.post('/web/main/qrcode/load', {
                    type: this.qrcodetype,
                    phone: this.session.user.phone
                })
                this.loading = false
                this.qrcode = res.data.qrcode
            },
            qrcodeScaned(res) {
                if (res.data.error) {
                    this.binderror = res.data.error
                    this.$Message.error(res.data.error)
                } else {
                    this.bind = true
                    this.qrcode = null
                    if (res.data.type == 'bind') {
                        this.session.user.pubopenid = res.data.pubopenid
                    } else if (res.data.type == 'unbind') {
                        this.session.user.pubopenid = null
                    }
                }
            },
            savePhone() {
                this.loading = true
                this.$api.post('/web/session/profile/phone/update', {
                    phone: this.form.phone,
                    code: this.form.smscode,
                }).then(res => {
                    if (res.data.success) {
                        this.codeSend = false
                        this.cd = -1
                        this.phoneInputStep = 1
                        this.phoneInput = false
                        this.$Message.success('更新成功')
                        this.session.user.phone = this.form.phone
                        this.session.zhanghao.user.phone = this.form.phone
                    }
                    this.loading = false
                }, () => {
                    this.loading = false
                })
            },
            checkCode(phone) {
                this.loading = true
                this.$api.post('/web/session/profile/smscode/check', {
                    phone: phone,
                    code: this.form.smscode,
                }).then(res => {
                    if (res.data.success) {
                        this.codeSend = false
                        this.cd = -1
                        this.phoneInputStep = 2
                        this.form.smscode = null
                    }
                    this.loading = false
                }, () => {
                    this.loading = false
                })
            },
            sendCode(phone) {
                if (!phone || !/^1\d{10}$/.test(phone)) {
                    this.$Message.warning('请输入正确手机号')
                    return
                }
                this.loading = true
                this.$api.post('/web/session/profile/smscode/send', {
                    phone: phone
                }).then(res => {
                    if (res.data.success) {
                        this.codeSend = true
                        this.cd = 60
                        this.runCD()
                    }
                    this.loading = false
                }, () => {
                    this.loading = false
                })
            },
            runCD() {
                this.cd--
                if (this.cd > 0) {
                    setTimeout(() => {
                        this.runCD()
                    }, 1000)
                }
            },
            nameChanged() {
                let that = this
                that.loading = true
                that.$api.post('/web/session/profile/update', {
                    form: { 'zhenshixingming': that.form.zhenshixingming }
                }).then(res => {
                    if (res.data.success) {
                        that.$Message.success('更新成功')
                        that.session.zhanghao.name = that.form.zhenshixingming
                        that.session.z.name = that.form.zhenshixingming
                    }
                    that.loading = false
                }, () => {
                    that.loading = false
                })
                that.nameInput = false
            },
            async loadData() {
                let that = this
                that.loading = true
                let res = await that.$api.post('/web/session/profile/load', {})
                this.session = res.data.session
                this.zhengshuguanli = res.data.zhengshuguanli
                this.yunxuweixin = res.data.yunxuweixin
                if (this.session.zhanghao.jueses && this.session.zhanghao.jueses.findOne({ name: '集团管理员' })) {
                    this.session.zhanghao.jituanadmin = true
                }
                this.hideChildren()
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/common/ProfileForm.vue?3b82ea50